import * as actionType from "../../../constants";
import * as commonData from "../../../Common";

export const createStatus = (inputs) => async (dispatch) => {
  const url = commonData.commonData().apiUrl;
  try {
    const response = await fetch(`${url}system/status/create`, {
      method: "post",
      body: JSON.stringify(inputs),
    });
    const rdata = await response.json();
    if (rdata.code === 200) {
      dispatch({
        type: actionType.CREATE_STATUS,
        payload: {
          status: rdata.data.status,
          message: rdata.message,
          statusType: rdata.status,
          board: true,
          code: rdata.code,
        },
      });
    }
  } catch (error) {
    console.log(error.message);
  }
};

export const updateStatus = (inputs) => async (dispatch) => {
  const url = commonData.commonData().apiUrl;
  try {
    const response = await fetch(`${url}system/status/update`, {
      method: "post",
      body: JSON.stringify(inputs),
    });
    const rdata = await response.json();
    if (rdata.code === 200) {
      dispatch({
        type: actionType.UPDATE_STATUS,
        payload: {
          status: rdata.data,
          board: true,
          message: rdata.message,
          statusType: rdata.status,
          code: rdata.code,
        },
      });
    } else {
      dispatch({
        type: actionType.UPDATE_STATUS,
        payload: {
          status: [],
          board: true,
          message: rdata.message,
          statusType: rdata.status,
          code: rdata.code,
        },
      });
    }
  } catch (error) {
    console.log(error.message);
  }
};
